import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { PIPELINES_ACTION_TYPE } from '../actions';

const initialState = {
  columnDefinitions: {},
  pipelines: {},
};

const pipelinesReducer = (state = initialState, { type, payload, meta }) =>
  produce(state, draft => {
    switch (type) {
      case PIPELINES_ACTION_TYPE.GET_PIPELINES:
        draft.pipelines = payload || initialState.pipelines;
        break;

      case PIPELINES_ACTION_TYPE.SET_PIPELINES:
        draft.pipelines = payload || draft.pipelines;
        break;

      case PIPELINES_ACTION_TYPE.MERGE_PIPELINES:
        (payload || []).forEach(pipeline => {
          draft.pipelines[pipeline.id] = { ...draft.pipelines[pipeline.id], ...pipeline };
        });
        break;

      case PIPELINES_ACTION_TYPE.GET_PIPELINES_COLUMN_DEFINITIONS:
        draft.columnDefinitions = payload || initialState.columnDefinitions;
        break;

      case PIPELINES_ACTION_TYPE.CREATE_PIPELINE:
      case PIPELINES_ACTION_TYPE.EDIT_PIPELINE:
        draft.pipelines[payload.id] = payload;
        break;

      case PIPELINES_ACTION_TYPE.DELETE_PIPELINE:
        delete draft.pipelines[meta.id];
        break;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default pipelinesReducer;
